import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const Skeleton = ({ classes }) => (
  <React.Fragment>
    <div className={`card-skeleton ${classes}`}>
      <div className={`image-placeholder ${classes}`} />
      <div className={`body-wrap ${classes}`}>
        <div className={`logo-placeholder ${classes}`} />
        <div className={`text-wrap ${classes}`}>
          <div className="text-placeholder long" />
          <div className="text-placeholder short" />
          {classes?.includes('tvGuidePlaceholder') && <div className="text-placeholder description" />}
        </div>
      </div>
    </div>
    <style jsx>{styles}</style>
  </React.Fragment>
)
Skeleton.propTypes = {
  classes: PropTypes.string,
}
Skeleton.defaultProps = {
  classes: '',

}
export default Skeleton
